import {GameProvider} from '@gongxigames/framework/slotV2/types/GameProvider';
import {ComponentsConfigs} from '@gongxigames/framework/core/types/systemComponentsTypes';
import {rubyUIComponentsConfig} from '@gongxigames/framework/slot/configs/components/rubyUIComponentsConfig';
import {koalaUIComponentsConfig} from '@gongxigames/framework/slot/configs/components/koalaUIComponentsConfig';
import {koalaComponentsConfig} from '@gongxigames/framework/slot/configs/components/koalaComponentsConfig';

// TODO clean build
// @gongxigames/framework/slot/configs/components/rubyUIComponentsConfig
// shouldn't be included for koala build
const providerUIComponentsMap: Map<GameProvider, ComponentsConfigs> = new Map([
    ['ruby', rubyUIComponentsConfig],
    ['koala', koalaUIComponentsConfig]
]);

const providerComponentsMap: Map<GameProvider, ComponentsConfigs> = new Map([
    ['ruby', {}],
    ['koala', koalaComponentsConfig]
]);

export function getProviderUIComponents(isStateMachine: boolean, gameProvider: GameProvider | undefined): ComponentsConfigs {
    if (isStateMachine && gameProvider) {
        return providerUIComponentsMap.get(gameProvider) || rubyUIComponentsConfig;
    } else {
        return {};
    }
}

export function getProviderComponents(isStateMachine: boolean, gameProvider: GameProvider | undefined): ComponentsConfigs {
    if (isStateMachine && gameProvider) {
        return providerComponentsMap.get(gameProvider) || koalaComponentsConfig;
    } else {
        return {};
    }
}